/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.0.0
 */

import { LOCATION_CHANGE } from 'connected-react-router';
import produce from 'immer';
import { Reducer } from 'redux';

import { TModalActions } from './modalActions';
import {
    MODAL_CLOSE,
    MODAL_CLOSE_ALL,
    MODAL_OPEN,
    MODAL_RENDER,
    MODAL_SET_PARAMS,
    MODAL_SET_STATUS,
} from './modalConstants';
import { EModalStatus, IModalList } from './types/modalTypes';

export interface IModalReducer {
    currentModal: string;
    modals: IModalList;
}

export const initialModalState: IModalReducer = {
    currentModal: '',
    modals: {},
};

const modalReducer: Reducer<IModalReducer, TModalActions> = (state = initialModalState, action: TModalActions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case MODAL_RENDER:
                const { id, ...configuration } = action.payload;
                draft.currentModal = id;
                draft.modals[id] = { ...configuration, isOpen: true, status: EModalStatus.start };
                break;
            case MODAL_CLOSE:
                draft.currentModal = '';
                delete draft.modals[action.payload];
                break;
            case MODAL_CLOSE_ALL:
            case LOCATION_CHANGE:
                draft.currentModal = '';
                draft.modals = {};
                break;

            case MODAL_SET_STATUS:
                draft.modals[draft.currentModal].status = action.payload.status;
                break;

            case MODAL_SET_PARAMS:
                draft.modals[draft.currentModal].modalParams = {
                    ...draft.modals[draft.currentModal].modalParams,
                    ...action.payload.modalParams,
                };
                break;

            // open modal intercept by middleware: modalOpenMiddleware
            case MODAL_OPEN:
            default:
                break;
        }
    });

export default modalReducer;
